@if (documentsMenu) {
  <div class="join-file-documents">
    <button type="button" class="join-file-documents-btn" (click)="openDocuments($event)" [title]="'documents.openFromRecordHelp' | translate">
      <i class="fa-solid fa-folder-open" aria-hidden="true"></i>{{ 'documents.openFromRecord' | translate }}
    </button>
  </div>
}
<iu-input-file-ui
  customUpload="true"
  [adTab_ID]="adTab_ID"
  [adTable_ID]="adTable_ID"
  [additionalUploadInformations]="tags"
  [auto]="false"
  [data]="{ isParam: false, columnName: 'join-file' }"
  [fromNotes]="fromNotes"
  [isAttachment]="true"
  [multiple]="true"
  [record_id]="record_id"
  [searchInformations]="baseSearch"
  [supportLinks]="true"
  [type]="fromNotes ? 'NOTES' : 'ATTACHEMENT'"
  (nbUploadedFilesChangeEmitter)="updateNbUploadedFiles($event)"
  (openFileOnSideEmitter)="openFileOnSide($event)"
  (uploadEnd)="uploadEnd.emit($event)" />
